<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('report.config.change')}}</h2>
        <ul class="app-breadcrumb breadcrumb">          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/report/reportTemplateList">
              <span>{{$t('tlt.reportTemplate')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/report/reportTemplateEdit">
              <span>{{$t('report.template.new')}}</span>
            </router-link>
          </li>          
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('reportTemplate')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('lbl.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="addTemplate()">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('report.template.templateName')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="templateName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('templateName') }"
                  v-model="templateName"
                  type="text"
                />
                <span
                  v-show="errors.has('templateName')"
                  class="lbl-obg"
                >{{ errors.first('templateName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('report.template.templateType')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="templateType"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('templateType') }"
                  v-model="templateType"
                  type="text"
                />
                <span
                  v-show="errors.has('templateType')"
                  class="lbl-obg"
                >{{ errors.first('templateType') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('report.template.templateFile')}}:
                </label>
                <File :placeholder="templateFileName" v-model="templateFile" @getFile="getFile($event)"></File>
                <span
                  v-show="errors.has('templateFile')"
                  class="lbl-obg"
                >{{ errors.first('templateFile') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('report.template.dirPath')}}:
                </label>
                 <input
                  v-validate="'required'"
                  name="dirPath"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('dirPath') }"
                  v-model="dirPath"
                  type="text"
                />
                <span
                  v-show="errors.has('dirPath')"
                  class="lbl-obg"
                >{{ errors.first('dirPath') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.cronExpression')}}:
                </label>
                 <input
                  v-validate="'required'"
                  name="cronExpression"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('cronExpression') }"
                  v-model="cronExpression"
                  type="text"
                />
                <span
                  v-show="errors.has('cronExpression')"
                  class="lbl-obg"
                >{{ errors.first('cronExpression') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('report.template.isSchedule')}}:
                </label>
                <select class="form-control form-control-sm" v-model="scheduleStatus">
                  <option value=1>{{ $t("report.template.run") }}</option>
                  <option value=0>{{ $t("report.template.stop") }}</option>
                </select>
                <span
                  v-show="errors.has('scheduleStatus')"
                  class="lbl-obg"
                >{{ errors.first('scheduleStatus') }}</span>
              </div> 
            </div>
            <div>
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('report.template.templateConfig')}}:
                <button class="btn btn-primary" type="button" v-on:click="formateJsonData()">
                  <span class="text">{{$t('report.template.formateJsonData')}}</span>
                </button>
              </label>
              <Json ref="jsonEdit"  v-model="templateConfig"/>
            </div>
            <div>
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('report.template.runtimeParam')}}:
              </label>
              <table class="table table-striped table-hover" >
                <thead>
                  <tr>
                    <td>
                      <div scope="col">
                        {{$t("report.template.placeholder")}}
                      </div>
                    </td>
                    <td>
                      <div scope="col">
                        {{$t("report.template.paramName")}}
                      </div>
                    </td>
                    <td>
                      <div scope="col">
                        {{$t("report.template.paramType")}}
                      </div>
                    </td>
                    <td>
                      <div scope="col">
                        {{$t("report.template.paramValue")}}
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="col in runConfig" v-bind:key="col.paramName">
                    <td>
                      <div scope="col">
                          {{col.paramName}}
                      </div>
                    </td>
                    <td>
                      <div scope="col">
                        <input class="form-control" v-model="col.paramDesc">
                      </div>
                    </td>
                    <td>
                      <div scope="col">
                        <select class="form-control"  v-model="col.paramType">
                          <option selected="selected">{{$t("report.template.time")}}</option>
                          <option >{{$t("report.template.text")}}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div v-if="col.paramType == 'Text Type' || col.paramType == '文本类型'" scope="col">
                        <b-form-input v-model="col.paramValue"></b-form-input>
                      </div>
                      <div v-if="col.paramType == 'Time Type' || col.paramType == '时间类型'" scope="col">
                        <select class="form-control"  v-model="col.paramValue">
                          <option selected="selected" value="thisWeekStart">{{$t("report.template.thisWeekStart")}}</option>
                          <option value="thisWeekEnd">{{$t("report.template.thisWeekEnd")}}</option>
                          <option value="lastWeekStart">{{$t("report.template.lastWeekStart")}}</option>
                          <option value="lastWeekEnd">{{$t("report.template.lastWeekEnd")}}</option>
                          <option value="thisMonthStart">{{$t("report.template.thisMonthStart")}}</option>
                          <option value="thisMonthEnd">{{$t("report.template.thisMonthEnd")}}</option>
                          <option value="lastMonthStart">{{$t("report.template.lastMonthStart")}}</option>
                          <option value="lastMonthEnd">{{$t("report.template.lastMonthEnd")}}</option>
                          <option value="thisQuarterStart">{{$t("report.template.thisQuarterStart")}}</option>
                          <option value="thisQuarterEnd">{{$t("report.template.thisQuarterEnd")}}</option>
                          <option value="lastQuarterStart">{{$t("report.template.lastQuarterStart")}}</option>
                          <option value="lastQuarterEnd">{{$t("report.template.lastQuarterEnd")}}</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import Json from "@/views/report/jsonEdit/JsonEdit";
import File from "@/views/report/jsonEdit/FileUpload";

import { createHelpers } from 'vuex-map-fields';
import { mapActions } from "vuex";
import { fields }  from "@/model/report/ReportTemplate";

import _ from 'lodash';

const { mapFields } = createHelpers({
  getterType: 'reportTemplate/getField',
  mutationType: 'reportTemplate/updateField',
})

export default {
  name: "reportTemplateEdit",
  components: { Json, File },
  data() {
    return {
      tmpFile: null,
      runConfig: null
    };
  },
  computed: {
    ...mapFields(fields),
    runtimeParam: {
      get() {
        let tempJson = JSON.parse(this.$store.state.reportTemplate.entity.runtimeParam);
        return tempJson;
      },
      set(value) {
        this.$store.commit("reportTemplate/setRuntimeParam", JSON.stringify(value))
      }
    },
    templateConfig: {
      get() {
        this.changeRunTimeConfig();
        return JSON.parse(this.$store.state.reportTemplate.entity.templateConfig)
      },
      set(value) {
        this.$store.commit("reportTemplate/setTemplateConfig", value)
      }
    }
  },
  methods: {
    ...mapActions("base", ["MMFbackToList"]),
    changeRunTimeConfig() {
      this.runConfig = this.runConfig == null ? (this.runtimeParam == null ? [] : this.runtimeParam) : this.runConfig
      let templateConfigJson = JSON.parse(this.$store.state.reportTemplate.entity.templateConfig);
        try{
          let settings = templateConfigJson["sheetSettings"]
          let tmpList = [];
          for(var sheetName in settings) {
            let jsonArray = settings[sheetName];
            if(jsonArray !== null) {
              for(var item of jsonArray) {
                let sqlString = item["sql"]+item["queryParam"];
                console.log("match ocupy,queryParam is",item["queryParam"])
                console.log("match ocupy,sqlString is",sqlString)
                var ocupyParamPatt = /\s+\?[0-9]+/g;
                let ocupyParamList = sqlString.match(ocupyParamPatt);
                if(ocupyParamList !== null) {
                  for(var ocupyParam of ocupyParamList) {
                    ocupyParam = _.trim(ocupyParam)
                    let currentParam = this.checkOcupyParamConstains(this.runConfig, ocupyParam);
                    if(currentParam == null)
                      tmpList.push({paramName: ocupyParam, paramType: "text", paramDesc: "", paramValue: ""})
                    else {
                      if(this.checkOcupyParamConstains(tmpList, ocupyParam) == null)
                        tmpList.push(currentParam)
                    }
                  }
                }
              }
            }
          }
          this.runConfig = tmpList;
          this.runtimeParam = this.runConfig;
        }catch(err) {
          console.log(err)
        }
    },
    addTemplate(){
      let formData = new FormData()

      if(this.tmpFile !== null) {
        formData.append('templateFile', this.tmpFile)
        this.templateFileName = this.tmpFile.name
      }
      if(this.excelTemplate !== null)
        formData.append('excelTemplate', this.excelTemplate)
      if(this.templateName !== null)
        formData.append('templateName', this.templateName)
      if(this.templateConfig !== null)
        formData.append('templateConfig', JSON.stringify(this.templateConfig))
      if(this.templateType !== null)
        formData.append('templateType', this.templateType)
      if(this.dirPath !== null)
        formData.append('dirPath', this.dirPath)
      if(this.templateFileName !== null)
        formData.append('templateFileName', this.templateFileName)
      if(this.id !== null)
        formData.append('id', this.id)
      if(this.userId !== null)
        formData.append('userId', this.userId)
      if(this.runtimeParam !== null)
        formData.append('runtimeParam', JSON.stringify(this.runConfig))
      if(this.cronExpression !== null && this.cronExpression !== undefined)
        formData.append('cronExpression', this.cronExpression)
      if(this.scheduleStatus !== null && this.scheduleStatus !== undefined)
        formData.append('scheduleStatus', this.scheduleStatus)
    
      this.$store.dispatch('reportTemplate/addTemplate', formData);
    },
    getFile(file) {
      if(file !== null) {
        this.tmpFile = file
      }
    },
    formateJsonData(){
      this.$refs.jsonEdit.formatJsonData();
    },
    checkOcupyParamConstains(dataList, ocupyParam) {
      for(var item of dataList) {
        if(item["paramName"] == ocupyParam)
          return item;
      }
      return null;
    },
  }
};
</script>